export const IS_DEVELOPMENT_ENVIRONMENT = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION_ENVIRONMENT = process.env.NODE_ENV !== 'development';

export const BASE_URL = IS_PRODUCTION_ENVIRONMENT ? 'https://technobabblenerdtalk.nl/' : 'http://localhost:1234/';
export const API_BASE_URL = IS_PRODUCTION_ENVIRONMENT ? 'https://api.technobabblenerdtalk.nl/api/v1/' : 'http://localhost:5000/api/v1/';
